<template>
  <div>
    <el-form role="form" @submit.prevent.native="onSubmit">
    <div class="row">
      <div class="col-md-6">
        <base-input v-uppercase v-model="job.description" label="Description"></base-input>
      </div>
    </div>
    <base-button md type="primary" native-type="submit">Save</base-button>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Select, Option, Form } from "element-ui";
export default {
   directives: {
    uppercase: {
      inserted: function (el, _, vnode) {
        el.addEventListener("input", async function (e) {
          const modified = e.target.value
            .split(" ")
            .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      },
    },
  },
  data: () => {
    return {};
  },

  computed: {
    ...mapState("job", ["job"])
  },
  methods: {
    ...mapActions({
      saveJob: "job/saveJob",
      updateJob: "job/updateJob",
      getJobs: "job/getJobList"
    }),
    onSubmit() {
      if (this.job.jobId) {
        this.updateJob().then(res => {
          this.$notify({
            message: "Job Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.getJobs();
          this.$emit("close");
        });
      } else {
        this.saveJob().then(res => {
          this.$notify({
            message: "Job Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getJobs();
          this.$emit("close");
        });
      }
    }
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form
  }
};
</script>